/**
 * SECTION 2B JS
 *
 * DATA TO BE STORED IN THE BACKEND FOR THIS:
 * - 
 *
 */
import $ from 'jquery';
import chartist from './chartist.min.js';
window.jQuery = $;

export default {
    init() {
        /*
         * Initialise Section 2B, data
         * UI interaction functions etc
         */
       //console.log( 'Section 2B - init' );

        this.aon_section_2b_data = [];
        
        // Get any existing saved data...
        if ( $( '#business_plan' ).length > 0 ) { // If Business Plan page then load live data...
			if ( $( '#section_2b_data_json' ).val() != '' ) { // Check there's some value before we try and load anything...
				console.log( '2B Data Load live - Business Plan...' );
				this.loadData( 'load_live' );
				calcWeeklyPercentageForBusinessPlan();
				calcMonthlyPercentageForBusinessPlan();
				$( '.business_plan_accordion ul.accordion' ).on( 'down.zf.accordion', function(event) {
					renderChart();
				});
			}
            
        } else { // If not Business Plan page then we are in 2B...
            if ( $( '#section_2b_data_json' ).val() != '' ) { // If JSON data field is not empty then we presume this is saved data and try to load it...
				console.log( '2B Data Load live - 2B...' );
                this.loadData( 'load_live' );
                calcWeeklyPercentage();
                calcMonthlyPercentage();
                renderChart();

            } else { // If no saved data then we start with a default data structure...
                this.loadData( 'start' ); 
            }
            //this.loadData( 'load_demo' );
        }
        
        
        function renderChart() { 
           //console.log( 'start - rendering chart...' );
            var a = parseFloat( $( '.weekly_percent_making_work' ).text() * 1 );
            var b = parseFloat( $( '.weekly_percent_business_research' ).text() * 1 );
            var c = parseFloat( $( '.weekly_percent_creative_play' ).text() * 1 );
            var d = parseFloat( $( '.weekly_percent_selling_marketing' ).text() * 1 );
            var e = parseFloat( $( '.weekly_percent_general_admin' ).text() * 1 );
            var f = parseFloat( $( '.weekly_percent_managing_money' ).text() * 1 );
            
            
            var data = {
                labels: [a+'%', b+'%', c+'%', d+'%', e+'%', f+'%'],
                series: [a, b, c, d, e, f]
            };
    
            var options = {
                labelInterpolationFnc: function(value) {
                    return value[0];
                }
            };

            var responsiveOptions = [
                ['screen and (max-width: 639px)', {
                    labelInterpolationFnc: function(value) {
                        return value;
                    }
                }],
                ['screen and (min-width: 640px)', {
                    chartPadding: 30,
                    labelOffset: 85,
                    labelDirection: 'explode',
                    labelInterpolationFnc: function(value) {
                        return value;
                    }
                }],
                ['screen and (min-width: 1024px)', {
                    labelOffset: 100,
                    chartPadding: 65
                }]
            ];

            new chartist.Pie( '.ct-chart', data, options, responsiveOptions );
            
           //console.log( 'end - rendering chart...' );
        }
        
        function calcMonthHours( src, targ ) {
            var month_hours = src.val() * 4;
            targ.val( month_hours );
            return month_hours;
        }
        
        function percentage( partialValue, totalValue ) {
           return (100 * partialValue) / totalValue;
        } 
        
        function calcWeeklyPercentage() {
            // get total weekly hours...
            var hours_per_week_making_work = $( '#hours_per_week_making_work' );
            var hours_per_week_business_research = $( '#hours_per_week_business_research' );
            var hours_per_week_creative_play = $( '#hours_per_week_creative_play' );
            var hours_per_week_selling_marketing = $( '#hours_per_week_selling_marketing' );
            var hours_per_week_general_admin = $( '#hours_per_week_general_admin' );
            var hours_per_week_managing_money = $( '#hours_per_week_managing_money' );
            
            var a = parseFloat( hours_per_week_making_work.val() * 1 );
            var b = parseFloat( hours_per_week_business_research.val() * 1 );
            var c = parseFloat( hours_per_week_creative_play.val() * 1 );
            var d = parseFloat( hours_per_week_selling_marketing.val() * 1 );
            var e = parseFloat( hours_per_week_general_admin.val() * 1 );
            var f = parseFloat( hours_per_week_managing_money.val() * 1 );
            var total = a + b + c + d + e + f;
            
            $( '.weekly_percent_making_work' ).text( ( ( 100 * a ) / total ).toFixed( 2 ) );
            $( '.weekly_percent_business_research' ).text( ( ( 100 * b ) / total ).toFixed( 2 ) );
            $( '.weekly_percent_creative_play' ).text( ( ( 100 * c ) / total ).toFixed( 2 ) );
            $( '.weekly_percent_selling_marketing' ).text( ( ( 100 * d ) / total ).toFixed( 2 ) );
            $( '.weekly_percent_general_admin' ).text( ( ( 100 * e ) / total ).toFixed( 2 ) );
            $( '.weekly_percent_managing_money' ).text( ( ( 100 * f ) / total ).toFixed( 2 ) );
            
            if ( total > 0 ) {
                $( '.trigger_chart_next' ).removeClass( 'disabled' );
            } else {
                $( '.trigger_chart_next' ).addClass( 'disabled' );
            }
            
        }
        
        function calcMonthlyPercentage() {
            // get total monthly hours...
            var hours_per_month_making_work = $( '#hours_per_month_making_work' );
            var hours_per_month_business_research = $( '#hours_per_month_business_research' );
            var hours_per_month_creative_play = $( '#hours_per_month_creative_play' );
            var hours_per_month_selling_marketing = $( '#hours_per_month_selling_marketing' );
            var hours_per_month_general_admin = $( '#hours_per_month_general_admin' );
            var hours_per_month_managing_money = $( '#hours_per_month_managing_money' );
            
            var a = parseFloat( hours_per_month_making_work.val() * 1 );
            var b = parseFloat( hours_per_month_business_research.val() * 1 );
            var c = parseFloat( hours_per_month_creative_play.val() * 1 );
            var d = parseFloat( hours_per_month_selling_marketing.val() * 1 );
            var e = parseFloat( hours_per_month_general_admin.val() * 1 );
            var f = parseFloat( hours_per_month_managing_money.val() * 1 );
            var total = a + b + c + d + e + f;
            
            $( '.monthly_percent_making_work' ).text( ( ( 100 * a ) / total ).toFixed( 2 ) );
            $( '.monthly_percent_business_research' ).text( ( ( 100 * b ) / total ).toFixed( 2 ) );
            $( '.monthly_percent_creative_play' ).text( ( ( 100 * c ) / total ).toFixed( 2 ) );
            $( '.monthly_percent_selling_marketing' ).text( ( ( 100 * d ) / total ).toFixed( 2 ) );
            $( '.monthly_percent_general_admin' ).text( ( ( 100 * e ) / total ).toFixed( 2 ) );
            $( '.monthly_percent_managing_money' ).text( ( ( 100 * f ) / total ).toFixed( 2 ) );
            
        }
        
        // For Business Plan page rendering only...
        function calcWeeklyPercentageForBusinessPlan() {
            // get total weekly hours...
            var weekly_hours_making_work = $( '.weekly_hours_making_work' );
            var weekly_hours_business_research = $( '.weekly_hours_business_research' );
            var weekly_hours_creative_play = $( '.weekly_hours_creative_play' );
            var weekly_hours_selling_marketing = $( '.weekly_hours_selling_marketing' );
            var weekly_hours_general_admin = $( '.weekly_hours_general_admin' );
            var weekly_hours_managing_money = $( '.weekly_hours_managing_money' );
            
            var a = parseFloat( weekly_hours_making_work.text() * 1 );
            var b = parseFloat( weekly_hours_business_research.text() * 1 );
            var c = parseFloat( weekly_hours_creative_play.text() * 1 );
            var d = parseFloat( weekly_hours_selling_marketing.text() * 1 );
            var e = parseFloat( weekly_hours_general_admin.text() * 1 );
            var f = parseFloat( weekly_hours_managing_money.text() * 1 );
            var total = a + b + c + d + e + f;
            
            $( '.weekly_percent_making_work' ).text( ( ( 100 * a ) / total ).toFixed( 2 ) );
            $( '.weekly_percent_business_research' ).text( ( ( 100 * b ) / total ).toFixed( 2 ) );
            $( '.weekly_percent_creative_play' ).text( ( ( 100 * c ) / total ).toFixed( 2 ) );
            $( '.weekly_percent_selling_marketing' ).text( ( ( 100 * d ) / total ).toFixed( 2 ) );
            $( '.weekly_percent_general_admin' ).text( ( ( 100 * e ) / total ).toFixed( 2 ) );
            $( '.weekly_percent_managing_money' ).text( ( ( 100 * f ) / total ).toFixed( 2 ) );
            
        }
        
        // For Business Plan page rendering only...
        function calcMonthlyPercentageForBusinessPlan() {
            // get total monthly hours...
            var hours_per_month_making_work = $( '.monthly_hours_making_work' );
            var monthly_hours_business_research = $( '.monthly_hours_business_research' );
            var monthly_hours_creative_play = $( '.monthly_hours_creative_play' );
            var monthly_hours_selling_marketing = $( '.monthly_hours_selling_marketing' );
            var monthly_hours_general_admin = $( '.monthly_hours_general_admin' );
            var monthly_hours_managing_money = $( '.monthly_hours_managing_money' );
            
            var a = parseFloat( hours_per_month_making_work.text() * 1 );
            var b = parseFloat( monthly_hours_business_research.text() * 1 );
            var c = parseFloat( monthly_hours_creative_play.text() * 1 );
            var d = parseFloat( monthly_hours_selling_marketing.text() * 1 );
            var e = parseFloat( monthly_hours_general_admin.text() * 1 );
            var f = parseFloat( monthly_hours_managing_money.text() * 1 );
            var total = a + b + c + d + e + f;
            
            $( '.monthly_percent_making_work' ).text( ( ( 100 * a ) / total ).toFixed( 2 ) );
            $( '.monthly_percent_business_research' ).text( ( ( 100 * b ) / total ).toFixed( 2 ) );
            $( '.monthly_percent_creative_play' ).text( ( ( 100 * c ) / total ).toFixed( 2 ) );
            $( '.monthly_percent_selling_marketing' ).text( ( ( 100 * d ) / total ).toFixed( 2 ) );
            $( '.monthly_percent_general_admin' ).text( ( ( 100 * e ) / total ).toFixed( 2 ) );
            $( '.monthly_percent_managing_money' ).text( ( ( 100 * f ) / total ).toFixed( 2 ) );
            
        }
    
        
        // Force numeric input only...
        $( '.time_per_week_month input' ).keypress( function( event ) {
            if ( event.which != 8 && isNaN( String.fromCharCode( event.which ) ) ) {
               event.preventDefault(); //stop character from entering input
            }
        });
        
        $( 'body' ).on( 'keyup', '#hours_per_week_making_work', function( event ) {
            var month_hours = calcMonthHours( $( this ), $( '#hours_per_month_making_work' ) );
            $( '.weekly_hours_making_work' ).text( $( this ).val() );
            $( '.monthly_hours_making_work' ).text( month_hours );
            calcWeeklyPercentage();
            calcMonthlyPercentage();
            setWeeklyMonthly();
            event.preventDefault();
        });
        
        $( 'body' ).on( 'keyup', '#hours_per_week_business_research', function( event ) {
            var month_hours = calcMonthHours( $( this ), $( '#hours_per_month_business_research' ) );
            $( '.weekly_hours_business_research' ).text( $( this ).val() );
            $( '.monthly_hours_business_research' ).text( month_hours );
            calcWeeklyPercentage();
            calcMonthlyPercentage();
            setWeeklyMonthly();
            event.preventDefault();
        });
        
        $( 'body' ).on( 'keyup', '#hours_per_week_creative_play', function( event ) {
            var month_hours = calcMonthHours( $( this ), $( '#hours_per_month_creative_play' ) );
            $( '.weekly_hours_creative_play' ).text( $( this ).val() );
            $( '.monthly_hours_creative_play' ).text( month_hours );
            calcWeeklyPercentage();
            calcMonthlyPercentage();
            setWeeklyMonthly();
            event.preventDefault();
        });
        
        $( 'body' ).on( 'keyup', '#hours_per_week_selling_marketing', function( event ) {
            var month_hours = calcMonthHours( $( this ), $( '#hours_per_month_selling_marketing' ) );
            $( '.weekly_hours_selling_marketing' ).text( $( this ).val() );
            $( '.monthly_hours_selling_marketing' ).text( month_hours );
            calcWeeklyPercentage();
            calcMonthlyPercentage();
            setWeeklyMonthly();
            event.preventDefault();
        });
        
        $( 'body' ).on( 'keyup', '#hours_per_week_general_admin', function( event ) {
            var month_hours = calcMonthHours( $( this ), $( '#hours_per_month_general_admin' ) );
            $( '.weekly_hours_general_admin' ).text( $( this ).val() );
            $( '.monthly_hours_general_admin' ).text( month_hours );
            calcWeeklyPercentage();
            calcMonthlyPercentage();
            setWeeklyMonthly();
            event.preventDefault();
        });
        
        $( 'body' ).on( 'keyup', '#hours_per_week_managing_money', function( event ) {
            var month_hours = calcMonthHours( $( this ), $( '#hours_per_month_managing_money' ) );
            $( '.weekly_hours_managing_money' ).text( $( this ).val() );
            $( '.monthly_hours_managing_money' ).text( month_hours );
            calcWeeklyPercentage();
            calcMonthlyPercentage();
            setWeeklyMonthly();
            event.preventDefault();
        });
        
        var setWeeklyMonthly = () => { 
            this.saveWeeklyMonthly();
        }
        
        // Click on "trigger_chart" link...
        $( 'body' ).on( 'click', '.trigger_chart_next', function( event ) {
            renderChart();
            event.preventDefault();
        });
          

        // Click on 'save_data' to submit completed data to backend storage...
        $( 'body' ).on( 'click', '.save_data', ( event ) => {
            this.saveData();
        });
        
        /*if ( $( '#business_plan' ).length > 0 ) {
            this.loadData( 'load_live' );
            calcWeeklyPercentageForBusinessPlan();
            calcMonthlyPercentageForBusinessPlan();
            renderChart();
            
            //$( '.business_plan_accordion ul .accordion' ).on( 'down.zf.accordion', function(event) {
            $( '.business_plan_accordion ul.accordion' ).on( 'down.zf.accordion', function(event) {
                //alert('HI');
                renderChart();
            });
        }*/
        
        
        
        
    },
    
    saveWeeklyMonthly() {
       //console.log( "$( '#hours_per_week_making_work' ).val(); - " + $( '#hours_per_week_making_work' ).val() );
        this.aon_section_2b_data[ 0 ][ 'weekly_hours_making_work' ] = Number( $( '#hours_per_week_making_work' ).val() );
        this.aon_section_2b_data[ 0 ][ 'monthly_hours_making_work' ] = Number( $( '#hours_per_month_making_work' ).val() );
        this.aon_section_2b_data[ 0 ][ 'weekly_hours_business_research' ] = Number( $( '#hours_per_week_business_research' ).val() );
        this.aon_section_2b_data[ 0 ][ 'monthly_hours_business_research' ] = Number( $( '#hours_per_month_business_research' ).val() );
        this.aon_section_2b_data[ 0 ][ 'weekly_hours_creative_play' ] = Number( $( '#hours_per_week_creative_play' ).val() );
        this.aon_section_2b_data[ 0 ][ 'monthly_hours_creative_play' ] = Number( $( '#hours_per_month_creative_play' ).val() );
        this.aon_section_2b_data[ 0 ][ 'weekly_hours_selling_marketing' ] = Number( $( '#hours_per_week_selling_marketing' ).val() );
        this.aon_section_2b_data[ 0 ][ 'monthly_hours_selling_marketing' ] = Number( $( '#hours_per_month_selling_marketing' ).val() );
        this.aon_section_2b_data[ 0 ][ 'weekly_hours_general_admin' ] = Number( $( '#hours_per_week_general_admin' ).val() );
        this.aon_section_2b_data[ 0 ][ 'monthly_hours_general_admin' ] = Number( $( '#hours_per_month_general_admin' ).val() );
        this.aon_section_2b_data[ 0 ][ 'weekly_hours_managing_money' ] = Number( $( '#hours_per_week_managing_money' ).val() );
        this.aon_section_2b_data[ 0 ][ 'monthly_hours_managing_money' ] = Number( $( '#hours_per_month_managing_money' ).val() );
       //console.log( 'SAVE WEEKLY / MONTHLY VALUES' );
        console.table( this.aon_section_2b_data );
    },
    
    
    addDataEntry() {
        // Default variables for data structure...
        var weekly_hours_making_work = '';
        var monthly_hours_making_work = '';
        var weekly_hours_business_research = '';
        var monthly_hours_business_research = '';
        var weekly_hours_creative_play = '';
        var monthly_hours_creative_play = '';
        var weekly_hours_selling_marketing = '';
        var monthly_hours_selling_marketing = '';
        var weekly_hours_general_admin = '';
        var monthly_hours_general_admin = '';
        var weekly_hours_managing_money = '';
        var monthly_hours_managing_money = '';
        
        // Push default data to data structure array...
        this.aon_section_2b_data.push( { 
            weekly_hours_making_work,
            monthly_hours_making_work,
            weekly_hours_business_research,
            monthly_hours_business_research,
            weekly_hours_creative_play,
            monthly_hours_creative_play,
            weekly_hours_selling_marketing,
            monthly_hours_selling_marketing,
            weekly_hours_general_admin,
            monthly_hours_general_admin,
            weekly_hours_managing_money,
            monthly_hours_managing_money
            
            //
            // DOES THIS NEED THE PERCENTAGES TO BE SAVED AS WELL????
            //
            
        } );
        
        console.table( 'addDataEntry: ' + this.aon_section_2b_data );
    },
    
    loadData( mode ) {
        /*
         * Set Data.
         * Either load existing data from backend or set default blank data...
         */
        
        // Load data from backend...
        if ( mode == 'load_live' ) {
            // Load from json array in page
            //section_2b_data_json
			console.log( '2B Data - IN Load live - INIT...' );
            var aon_section_2b_data_json = $( '#section_2b_data_json' ).val();
            this.aon_section_2b_data = JSON.parse( aon_section_2b_data_json );
            $( '.weekly_hours_making_work' ).text( this.aon_section_2b_data[ 0 ][ 'weekly_hours_making_work' ] );
            $( '.monthly_hours_making_work' ).text( this.aon_section_2b_data[ 0 ][ 'monthly_hours_making_work' ] );
            $( '.weekly_hours_business_research' ).text( this.aon_section_2b_data[ 0 ][ 'weekly_hours_business_research' ] );
            $( '.monthly_hours_business_research' ).text( this.aon_section_2b_data[ 0 ][ 'monthly_hours_business_research' ] );
            $( '.weekly_hours_creative_play' ).text( this.aon_section_2b_data[ 0 ][ 'weekly_hours_creative_play' ] );
            $( '.monthly_hours_creative_play' ).text( this.aon_section_2b_data[ 0 ][ 'monthly_hours_creative_play' ] );
            $( '.weekly_hours_selling_marketing' ).text( this.aon_section_2b_data[ 0 ][ 'weekly_hours_selling_marketing' ] );
            $( '.monthly_hours_selling_marketing' ).text( this.aon_section_2b_data[ 0 ][ 'monthly_hours_selling_marketing' ] );
            $( '.weekly_hours_general_admin' ).text( this.aon_section_2b_data[ 0 ][ 'weekly_hours_general_admin' ] );
            $( '.monthly_hours_general_admin' ).text( this.aon_section_2b_data[ 0 ][ 'monthly_hours_general_admin' ] );
            $( '.weekly_hours_managing_money' ).text( this.aon_section_2b_data[ 0 ][ 'weekly_hours_managing_money' ] );
            $( '.monthly_hours_managing_money' ).text( this.aon_section_2b_data[ 0 ][ 'monthly_hours_managing_money' ] );
            
            $( '#hours_per_week_making_work' ).val( this.aon_section_2b_data[ 0 ][ 'weekly_hours_making_work' ] );
            $( '#hours_per_week_business_research' ).val( this.aon_section_2b_data[ 0 ][ 'weekly_hours_business_research' ] );
            $( '#hours_per_week_creative_play' ).val( this.aon_section_2b_data[ 0 ][ 'weekly_hours_creative_play' ] );
            $( '#hours_per_week_selling_marketing' ).val( this.aon_section_2b_data[ 0 ][ 'weekly_hours_selling_marketing' ] );
            $( '#hours_per_week_general_admin' ).val( this.aon_section_2b_data[ 0 ][ 'weekly_hours_general_admin' ] );
            $( '#hours_per_week_managing_money' ).val( this.aon_section_2b_data[ 0 ][ 'weekly_hours_managing_money' ] );
            
            $( '#hours_per_month_making_work' ).val( this.aon_section_2b_data[ 0 ][ 'monthly_hours_making_work' ] );
            $( '#hours_per_month_business_research' ).val( this.aon_section_2b_data[ 0 ][ 'monthly_hours_business_research' ] );
            $( '#hours_per_month_creative_play' ).val( this.aon_section_2b_data[ 0 ][ 'monthly_hours_creative_play' ] );
            $( '#hours_per_month_selling_marketing' ).val( this.aon_section_2b_data[ 0 ][ 'monthly_hours_selling_marketing' ] );
            $( '#hours_per_month_general_admin' ).val( this.aon_section_2b_data[ 0 ][ 'monthly_hours_general_admin' ] );
            $( '#hours_per_month_managing_money' ).val( this.aon_section_2b_data[ 0 ][ 'monthly_hours_managing_money' ] );
            
            
            
        } else if ( mode == 'load_demo' ) {
            
            // Using temp JSON source for now, but this would load from the backend...
             var aon_section_2b_data_json = '[';
                aon_section_2b_data_json += '{';
                aon_section_2b_data_json += '"weekly_hours_making_work":"10",';
                aon_section_2b_data_json += '"monthly_hours_making_work":"40",';
                aon_section_2b_data_json += '"weekly_hours_business_research":"3",';
                aon_section_2b_data_json += '"monthly_hours_business_research":"12",';
                aon_section_2b_data_json += '"weekly_hours_creative_play":"5",';
                aon_section_2b_data_json += '"monthly_hours_creative_play":"20",';
                aon_section_2b_data_json += '"weekly_hours_selling_marketing":"4",';
                aon_section_2b_data_json += '"monthly_hours_selling_marketing":"16",';
                aon_section_2b_data_json += '"weekly_hours_general_admin":"2",';
                aon_section_2b_data_json += '"monthly_hours_general_admin":"8",';
                aon_section_2b_data_json += '"weekly_hours_managing_money":"3",';
                aon_section_2b_data_json += '"monthly_hours_managing_money":"12"';
                aon_section_2b_data_json += '}';
                aon_section_2b_data_jsonb_data_json += ']';

            this.aon_section_2b_data = JSON.parse( aon_section_2b_data_json );

        } else if ( mode == 'start' ) {

            this.addDataEntry();
            
        }
        console.table( this.aon_section_2b_data );
  
    },
    
    saveData() {
        // Call AJAX request to WP / Rest API
        // Save completed data to backend...
        var jsonDataString = JSON.stringify( this.aon_section_2b_data );
       //console.log( 'jsonDataString: ' + jsonDataString );
        
       //console.log( '2B AJAX - START' );
        var meta = { 'section_2b_data_one' : jsonDataString };
        $.ajax({
            url: wpApiSettings.root + 'wp/v2/users/' + wpApiSettings.current_user_id,
            method: 'POST',
            beforeSend: function ( xhr ) {
                xhr.setRequestHeader( 'X-WP-Nonce', wpApiSettings.nonce );
            },
            data: {
                'meta' : meta
            }
        }).done( function ( response ) {
           //console.log( 'Response: ' );
           //console.log( response );
        });
       //console.log( '2B AJAX - END' );
        
       //console.log( 'Saving data via AJAX, saving the following:' );
        console.table( this.aon_section_2b_data );
    }
    
}